
<mat-card class="slidecontent">
  <div class="userdetails">
    <div class="usernameinfo">
      <!-- <div class="picname">
          <div class="pic">
              <img src="../../../../../assets/images/avatars/andrew.jpg" alt="">
          </div>
          <div class="name">
              <h3>Matt McAlpin</h3>
              <p>Resident</p>
          </div>
      </div> -->
      <div class="closedetail">
        <button mat-icon-button (click)="getClose(close)" ><mat-icon>close</mat-icon></button>
      </div>
          <!-- <div class="pmenu">
              <button mat-icon-button  [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
              <mat-menu #menu="matMenu" xPosition="before">
                  <button mat-menu-item>Profile Settings</button>
                  <button mat-menu-item>Delete</button>
                  </mat-menu>
          </div> -->
      </div>

      <div class="compdetail">
          <form class="">
              <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput placeholder="Name" value="Matt McAlpin">
              </mat-form-field>   
              <mat-form-field>
                  <mat-label>Company</mat-label>
                  <input matInput placeholder="Company" value="ECM">
                </mat-form-field>   
                <mat-form-field>
                  <mat-label>Title</mat-label>
                  <input matInput placeholder="Title" value="Signashare">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Email</mat-label>
                  <input matInput placeholder="Email" value="matt@signshare.com">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Type</mat-label>
                  <mat-select value="">
                    <mat-option value="">Signashare</mat-option>
                    <mat-option value="">Realty APX</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Importance</mat-label>
                  <mat-select value="">
                    <mat-option value="">10%</mat-option>
                    <mat-option value="">20%</mat-option>
                  </mat-select>
                </mat-form-field>  
                <mat-form-field>
                  <mat-label>Add Tag</mat-label>
                  <input matInput placeholder="Select or Add new" value="">
                </mat-form-field>
                     
            </form>
      </div>
  </div>
</mat-card>


<div class="overlay" (click)="getClose(close)"></div>

